import { render, staticRenderFns } from "./DocumentDetailWrapper.vue?vue&type=template&id=07d4fa48&"
import script from "./DocumentDetailWrapper.vue?vue&type=script&lang=js&"
export * from "./DocumentDetailWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports